import { createEnum } from "../utils/helpers";
import COSTCO_LOGO from "../assets/logo/Costco_Wholesale_logo.svg";
import trendsAndBenchmarkingIcon from "../assets/icons/trends-and-benchmarking.svg";
import disabilitySnapshotsIcon from "../assets/icons/disabilitySnapshots.svg";
import config from "../config";
import InitialIcon from "../assets/icons/High_volume_1.svg";
import High_volume_Icon from "../assets/icons/High_Volume_Icon.svg";
import leaveIcon from "../assets/icons/leave-icon.svg";
import changesIcon from "../assets/icons/changes-icon.svg";
import absenceIcon from "../assets/icons/absence-icon.svg";
import lifeView from "../assets/icons/report-life-icon.svg";
import paymentHistory from "../assets/icons/payment-history-icon.svg";
import disabilityIcon from "../assets/icons/disability-icon.svg";
import fileIcon from "../assets/icons/file_icon.svg";

// Datatable
export const paginationOptions = [5, 10, 50, 100, 200];
export const defaultPaginationItems = 10;

export const cacheDataForInSeconds = 300;

export const recordsType = createEnum(["LEAVE", "CLAIM"]);

export const ssnAccess = createEnum(["No Access", "Full Access", "Partial"]);

export const noDataPlaceholder = "—";

export const DASHBOARD_MESSAGES = {
    ALL_CHARTS_INSUFFICIENT_DATA:
        "<strong>Currently, the dataset selected does not meet the minimum threshold " +
        "required to generate a dashboard.</strong> " +
        "This is to protect privacy and ensure data integrity. " +
        "<strong>Tip:</strong> Adjust the selection above to generate graphs. " +
        "Reference the Help page for further support.",
    REQUEST_FAILED:
        "Your request failed, please try again or contact us for further assistance.",
};

export const displayLogo = /organization\/[^\/]+\/employees\/[^\/]+/g;

export const logos = {
    costco: COSTCO_LOGO,
};

export const dateFormat = "MM/DD/YYYY";
export const ownerTypeOrder = ["Personal", "Shared", "Standard"];
export const dataViewTypeOrder = [
    "Disability",
    "Leave",
    "Absence",
    "Payments",
    "Life",
    "Changes",
];

export const DATAVIEWTYPE =
    "Absence,Leave,Disability,Life,Payments,Changes,Documents";
export const SNAPSHOTDATAVIEWTYPE = "TrendsBenchmarking,ClaimSnapshot";

export const DATA_VIEW_TYPES = {
    DOCUMENTS: "Documents",
    LIFE: "Life",
    DISABILITY: "Disability",
    LEAVE: "Leave",
    ABSENCE: "Absence",
    PAYMENT_HISTORY: "PaymentHistory",
    CHANGES: "Changes",
};

export const SERVICE_IDENTIFIERS = {
    TAX_REPORTING: "CLAIMSTAXREPORTING",
    LEAVE_REPORTING: "CLAIMLEAVEREPORTING",
};

export const OWNER_TYPE = "Standard";
export const CUSTOM_DATE_RANGE = "Custom range";
export const absenceType = "Absence";
export const paymentHistoryType = "PaymentHistory";
export const leaveType = "Leave";
export const disabilityType = "Disability";
export const lifeType = "Life";
export const changesReportType = "Changes";
export const CONVERGE_TYPE = "Coverage type";
export const STATUS = "Status";
export const PAYMENT_STATUS = "Payment status";
export const PROTECTION_STATUS = "Protection status";
export const PLAN_REQUEST_STATUS = "Plan request status";
export const PERIOD_SCHEDULE_TYPE = "Period schedule type";
export const INCLUDE_HISTORICAL_LEAVE = "Include historical leave";
export const REPORTING_PERIOD = "Reporting Period";
export const APPLY_REPORTING_PERIOD_TO = "Apply Reporting Period To";
export const LEAVE_START_DATE_APPLY_OPTION = "Leave Start Date";
export const LEAVE_SUMMARY_SUBVIEW = "Leave Summary";
export const LEAVE_PERIOD_PROTECTION_DETAIL_SUBVIEW =
    "Leave Period Protection Detail";
export const LEAVE_DETAILS_SUBVIEW = "Leave Details";
export const LEAVE_CHANGES_SUBVIEW = "Leave Changes";
// Subviews where the Reporting Period bounds are extended (5 years back /
// 1 year forward) when "Apply Reporting Period To" = "Leave Start Date".
// Other subviews may still expose the Leave Start Date option but keep the
// backend-provided default bounds.
export const EXTENDED_LEAVE_START_DATE_SUBVIEWS = [
    LEAVE_SUMMARY_SUBVIEW,
    LEAVE_PERIOD_PROTECTION_DETAIL_SUBVIEW,
    LEAVE_DETAILS_SUBVIEW,
];
export const TRENDS_BY_YEAR = "trendsbyyear";
export const TRENDS_BY_QUARTER = "trendsbyquarter";
export const REPORTING_PERIOD_MAX_PAST_YEARS = 5;
export const REPORTING_PERIOD_MAX_FUTURE_YEARS = 1;
export const ANALYSIS_TYPE = "Analysis Type";
export const POLICIES_AND_DIVISIONS = "Policies and divisions";
export const POLICY_DIVISION_ELIGIBLE_COVERAGE_TYPES = [
    "STD",
    "SI-STD",
    "STD,SI-STD",
    "LTD",
    "SI-LTD",
    "LTD,SI-LTD",
];
export const REPORTING_GROUP = "Reporting group";
export const LEAVE_SCHEDULE_TYPE = "Leave Schedule Type";
export const INCLUDE_PFL_CLAIMS = "Include PFL claims";
export const COMPARE_YOUR_COMPANY_TO = "Compare your company to";
export const COMPARABLE_BUSINESS = "Comparable business";
export const All_Open_Absences = "All Open Absences";
export const Disability_Summary = "Disability Summary";
export const EMPLOYEE_ID = "employeeId";
export const EE_ID = "eeId";
export const LEAVE_ID = "leaveId";
export const CLAIM_ID = "claimId";

export const subview_mapping = {
    [LEAVE_SUMMARY_SUBVIEW]: "Summary",
    "All Open Leaves": "Summary",
    [LEAVE_PERIOD_PROTECTION_DETAIL_SUBVIEW]: "PeriodProtection",
    [LEAVE_DETAILS_SUBVIEW]: "Detailed",
    "Intermittent Leave": "IntermittentLeave",
    "Reduced Schedule Leave": "ReducedScheduleLeave",
    "Accommodation Report (TL)": "Accomodation",
    "Leave As Accommodation Report (TL)": "LeaveAsAccommodation",
    "Absence Overview": "Detailed",
    "Absence Summary": "Summary",
    "All Open Absences": "Summary",
    "Life Waiver of Premium": "Life",
    "Life - Paid Claims": "Payments",
    "Life - Pending Claims": "Claims",
    "Life Details": "Life",
    "Continuous Leave": "ContinuousLeave",
    "Summary Continuous Leave": "SummaryContinuousLeave",
};

export const claimStatusOpenValues = [
    "Open",
    "Approved",
    "Future Claim",
    "Open - Reasons",
    "Pending Evaluation",
    "Pending Review",
    "Review Complete",
    "Pre-File",
    "Received",
    "Pending Additional Information",
    "Pre-approved Future Claim",
    "Create New 30 Day Reminder",
    "Intake In Progress",
    "Pended",
];

export const default_subview_map = "Detailed";

export const currencyColumns = [
    "Payment Amount",
    "Federal Withholding",
    "Dental Insurance Premium",
    "Employee SS Tax",
    "Federal Withholding",
    "Gross Benefit in Period",
    "Local Withholding",
    "Medicare Tax",
    "Overpayment Reduction",
    "Post-Tax Total",
    "Pre-tax Medical Insurance",
    "Pre-Tax Total",
    "SS Offset",
    "State Offset",
    "State Withholding",
    "WC Offset",
    "Monthly Salary",
    "All Other Offsets",
    "SS Offset Amount",
    "Workers Compensation Offset",
    "FICA Amount",
    "Health Care Credit",
    "Health Care Credit To Date",
    "State Disability Offset Amount",
    "Paid to Date Amount",
    "Claimant Check Amount",
    "Gross Benefit Amount",
    "Deductions",
    "Offsets",
    "Weekly Salary",
];

export const LEAVE_AS_ACCOMMODATION_REPORT =
    "Leave As Accommodation Report (TL)";

export const ACCOMMODATION_REPORT = "Accommodation Report (TL)";

export const WEEK_NAMES = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

export const REPORTING_PERIOD_MESSGAE = {
    absenceApply:
        "The reporting period includes any claims/ leaves that fall within the selected date range based on the “Apply reporting period to” selection.",
    leaveTypeApply:
        "The reporting period includes any leaves that fall within the selected date range based on the “Apply reporting period to” selection.",
    disabilitytypeApply:
        "The reporting period includes any claims that fall within the selected date range based on the “Apply reporting period to” selection.",
    disabilityType:
        "Reporting period includes any claims that had a status update within the selected date range.",
    leaveType:
        "Reporting period includes any leaves that had a status update within the selected date range.",
    intermittentLeaveType:
        "Reporting period includes all leaves with any intermittent time taken within the selected date range.",
    continuousLeaveType:
        "Reporting period includes all leaves with absence time taken within the selected date range.",
    reducedScheduleLeaveType:
        "Reporting period includes all leaves with absence time taken within the selected date range.",
    paymentHistoryType:
        "Reporting period includes any claims that had a payment date within the selected date range.",
    changesReportType:
        "This report includes data between the period selected and the current date.",
    lifeType:
        "Reporting period includes any claims that had a status update within the selected date range.",
    lifePaidClaims:
        "Reporting period includes any claims that had a payment status date within the selected date range.",
    defaultMessage:
        "Reporting period includes any claims or leaves that had a status update within the selected date range.",
};

export const ACTIVE_ABSENCE_TYPES_MESSAGE = {
    absenceType:
        "Includes leaves and claims that were active at any time during the selected period, regardless of when they started or ended. Intermittent absences may be included even if no intermittent time was taken during the period.",
    leaveType:
        "Includes leaves that were active at any time during the selected period, regardless of when the leave started or ended. Intermittent absences may be included even if no intermittent time was taken during the period.",
    disabilitytype:
        "Includes claims that were active at any time during the selected period, regardless of when the claim began or ended.",
};

export const NO_TAX_REPORT_RECORDS_MESSAGE =
    "No reports were found. Tax reports are available here for Total Leave clients only. For Total Leave clients, try expanding the selected date range. To retrieve tax reports for non-Total Leave customers, please visit the Unum Services portal and select Tax Reports under the Claims tab. ";

export const decisionSummaryMap = {
    "As Certified": "Approved",
    "Mixed Decision": "Some Approved / Some Denied",
    "Pending Certification": "Pending",
    "Time Available": "Pending",
    "Waiting Period": "Pending",
    Denied: "Denied",
    Approved: "Approved",
    Pending: "Pending",
};

export const industryPeersList = {
    title: "Industry peers",
    bodyListTitle:
        "Below are the industry peers that your organization is compared with:",
    list: [
        "2511 Wood Household Furniture, Except Upholstered",
        "2512 Wood Household Furniture, Except Upholstered",
        "2514 Metal Household Furniture, Except Upholstered",
        "2515 Mattresses, Foundations, and Convertible Beds",
        "2517 Wood Televisions, Radio, Phonograph and Sewing Machine Cabinets",
        "2519 Household Furniture, Not Elsewhere Classified",
    ],
};

export const policiesList = {
    title: "Policies",
    bodyListTitle: "Below are the policies that are included:",
    list: [
        "00205136",
        "00205137",
        "00205075",
        "00205138",
        "00205136",
        "00205137",
        "00205075",
        "00205138",
    ],
};

export const reportItems = [
    {
        title: "Disability snapshot",
        icon: disabilitySnapshotsIcon,
        path: "disability-snapshot",
        button: "dashboard",
        text: "Discover key disability insights for your workforce",
        className: "disability-snapshot-content",
        iconClassName: "disability-snapshot-icon",
    },
    {
        title: "Trends and benchmarking",
        icon: trendsAndBenchmarkingIcon,
        path: "trendsAndBenchmarking",
        button: "dashboard",
        text: "Visualize key data and benchmark your business against industry peers",
        className: "trendsAndBenchmarking",
        iconClassName: "trendsAndBenchmarking-icon",
    },
    {
        title: "Costco Analytics Dashboards",
        icon: logos["costco"],
        path: "costco-analytics-dashboards",
        externalPath: config?.TABLEAU_CLOUD_COSTCO_DASHBOARD_URL,
        button: "dashboard",
        text: "Interactive analytics for leave, short term and long term disability",
        className: "trendsAndBenchmarking",
        iconClassName: "costco-logo-icon",
    },
];

export const PAYMENT_COMPONENT_IDS = {
    pc401kDeferral: ["401K Deferral"],
    accidentalDeathDismemberment: ["Accidental Death & Dismemberment", "ADD"],
    preTaxDental: [
        "Pre Tax Dental",
        "PREDEN",
        "Pre Tax Primary Dental Premium",
    ],
    postTaxCancer: [
        "Post-tax Cancer",
        "Cancer plan/Critical Illness",
        "CANPLN",
        "Post-Tax Cancer Plan",
    ],
    retirement: ["Retirement"],
    preTaxFlexSpenDaycare: ["Pre Tax Flex Spen Daycare", "PREFDC"],
    healthSavingsAccount: ["Health Savings Account", "HLTHSA"],
    groupSupplementalEmployeeLife: [
        "Group Supplemental Employee Life",
        "GSELIF",
    ],
    preTaxGroupSuppDependentLife: [
        "Pre Tax Group Supp Dependent Life",
        "PREGDL",
    ],
    preTaxFlexSpenHealthcare: ["Pre Tax Flex Spen Healthcare", "PREFSH"],
    premiumContribution: ["Premium Contribution", "PREMC"],
    preTaxCancerPlan: ["Pre-tax Cancer Plan", "PRECAN"],
    garnishment: ["Garnishment", "GARN"],
    postTaxGroupLegalServices: [
        "Post Tax Group Legal Services",
        "LGLADV",
        "Post-Tax Group Legal Services Instruction",
    ],
    postTaxVision: ["VISION", "Post Tax Primary Vision Premium"],
    preTaxMedical: [
        "PREMED",
        "Pre Tax Medical",
        "Pre Tax Primary Medical Premium",
    ],
    preTaxVision: ["Pre Tax Primary Vision Premium", "PREVIS"],
    dentalInsurancePremium: ["Post Tax Primary Dental Premium", "DENTAL"],
    generalPostTaxDeduction: ["General Post Tax Deduction", "MISCON"],
    generalPreTaxDeduction: ["General Pre Tax Deduction", "PREMSC"],
    postTaxMedical: [
        "Post-Tax Medical",
        "POSTMD",
        "Post Tax Primary Medical Premium",
    ],
    postTaxDependentLifeInsPremium: ["Post Tax Dependent Life Ins Premium"],
    postTaxLongTermDisabilityPremium: ["Post-Tax Long Term Disability Premium"],
    preTaxMedicalFlexibleSpendingAccount: [
        "Pre-Tax Medical Flexible Spending Account",
    ],
    postTaxVoluntaryLifeSpousePremium: [
        "Post-Tax Voluntary Life - Spouse Premium",
    ],
    postTaxVoluntaryLifeEmployeePremium: [
        "Post Tax Voluntary Life- Employee Premium",
    ],
    postTaxPersonalAccidentInsPremium: [
        "Post Tax Personal Accident Ins Premium",
    ],
    postTaxOtherADDPremium: ["Post Tax Other AD+D Premium", "GSADD"],
    postTaxPrimaryLifeInsPremium: ["Post Tax Primary Life Ins Premium", "LIFE"],
    preTaxDependentCareFlexSpendingAmt: [
        "Pre-Tax Dependent Care Flex Spending Account",
        "PREFSV",
    ],
};

export const HIGH_VOLUME_MESSAGES = {
    INITIAL: [
        {
            header: "To get started, please select a report above",
            subheader: "",
            color: "#015294",
            icon: InitialIcon,
        },
    ],

    REVIEW_FILTERS: [
        {
            header: (
                <>
                    Please select desired filters above and click{" "}
                    <span style={{ fontWeight: "bold" }}>Apply</span> to
                    continue
                </>
            ),
            subheader: "",
            color: "#015294",
            icon: InitialIcon,
            renderNote: (dataViewType) => {
                if (dataViewType === DATA_VIEW_TYPES.DOCUMENTS) {
                    return (
                        <div>
                            <span style={{ fontWeight: 600 }}>
                                Tax reports are available here for Total Leave
                                clients only.
                            </span>{" "}
                            To retrieve tax reports for non-Total Leave
                            customers, please visit the Unum Services portal and
                            select Tax Reports under the Claims tab.
                        </div>
                    );
                }

                return null;
            },
        },
    ],

    HIGH_VOLUME: [
        {
            header: "Your report contains a large amount of data.",
            subheader: (
                <>
                    For the best user experience, your report will be generated
                    in the background. Click{" "}
                    <span style={{ fontWeight: "bold" }}>Generate report</span>{" "}
                    below and we will notify you when it is ready to download.
                </>
            ),
            color: "#015294",
            button: "Generate report",
            icon: High_volume_Icon,
        },
    ],

    REPORT_GENERATED: [
        {
            header: "",
            subheader:
                "We're generating your report in the background. We'll notify you when it's ready to download.\nIn the meantime, feel free to keep exploring Unum Insights.",
            color: "#015294",
            icon: InitialIcon,
        },
    ],
};

export const REPORT_ITEMS = [
    {
        title: "Absence",
        icon: absenceIcon,
        path: "Absence",
        button: "absence",
        text: "Centralized report of all employee absences for disability and leave",
    },
    {
        title: "Leave",
        icon: leaveIcon,
        path: "Leave",
        button: "leave",
        text: "Review detailed information for federal, state, and corporate-level protections for your employees taking leave",
        className: "leave-content",
    },
    {
        title: "Wage Replacement",
        icon: disabilityIcon,
        path: "Disability",
        button: "wage replacement",
        text: "Details on short and long term disability claims and paid leaves",
        className: "disability-content",
    },
    {
        title: "Life",
        icon: lifeView,
        path: "Life",
        button: "life",
        text: "Review claim information for Life and Life Waiver of Premium",
        className: "lifeview",
    },
    {
        title: "Payment history",
        icon: paymentHistory,
        path: "PaymentHistory",
        button: "payment history",
        text: "Explore payment activity across claims and paid leaves ",
        className: "payment-history",
    },
    {
        title: "Changes",
        icon: changesIcon,
        path: "Changes",
        button: "changes",
        announcement: [
            { text: "Changes report is moving:", bold: true },
            {
                text: " Access to this report will soon be available under the ",
            },
            { text: "Leave", bold: true },
            {
                text: " tile, with additional change details available directly within leave reports.",
            },
        ],
        text: "The Changes report shows all leaves with data that has been updated or modified over a specified time period.",
        className: "changes-content",
    },
    {
        title: "Document Library",
        icon: fileIcon,
        path: "Documents",
        button: "document library",
        text: "View and download reports not available through real-time generation",
        notes: [{ text: "Note: For Total Leave clients only.", bold: true }],
        className: "documentlibrary-content",
    },
];
